import instance from "./instance";
class AdminAuthService {
  signup = async (data) => {
    let res = await instance({
      method: "post",
      url: "signup",
      data,
    });
    return res.data;
  };

  login = async (data) => {
    let res = await instance({
      method: "post",
      url: "login",
      data,
    });
    return res.data;
  };

  getCurrentUser = async (token) => {
    let { data } = await instance({
      method: "get",
      url: "getProfile",
    });
    return data;
  };

  startAuction = async () => {
    let { data } = await instance({
      method: "post",
      url: "startAuction",
    });
    return data;
  };

  resetAuction = async () => {
    let { data } = await instance({
      method: "put",
      url: "resetAuction",
    });
    return data;
  };

  stopAuction = async (id) => {
    let { data } = await instance({
      method: "put",
      url: "stopAuction/" + id,
    });
    return data;
  };

  getSession = async () => {
    let { data } = await instance({
      method: "get",
      url: "sessions",
    });
    return data;
  };

  setAuctionMode = async (auctionMode) => {
    let { data } = await instance({
      method: "put",
      url: "auctionMode",
      data: { auctionMode },
    });
    return data;
  };

  getAuctionRules = async () => {
    let { data } = await instance({
      method: "get",
      url: "auctionRules",
    });
    return data;
  };

  // Pass rules: null to clear the overrides and go back to defaults.
  setAuctionRules = async ({ auctionMode, rules }) => {
    let { data } = await instance({
      method: "put",
      url: "auctionRules",
      data: { auctionMode, rules },
    });
    return data;
  };

  getPlayerPool = async () => {
    let { data } = await instance({
      method: "get",
      url: "playerPool",
    });
    return data;
  };

  importWomenPlayers = async () => {
    let { data } = await instance({
      method: "post",
      url: "importWomenPlayers",
    });
    return data;
  };
}

export default new AdminAuthService();
